import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { AtSign } from "lucide-react";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ChangeEmailDialog({ className = "" }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user?.auth_provider && user.auth_provider !== "password") return null;

  const submit = async (e) => {
    e.preventDefault();
    const em = newEmail.trim().toLowerCase();
    if (!EMAIL_RE.test(em)) return toast.error("Inserisci un indirizzo email valido");
    if (em === (user?.email || "").toLowerCase()) return toast.error("La nuova email coincide con quella attuale");
    setBusy(true);
    try {
      await api.post("/auth/change-email", { new_email: em, current_password: password });
      toast.success("Email aggiornata. Accedi con la tua nuova email.");
      setOpen(false); setNewEmail(""); setPassword("");
      await logout();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button data-testid="open-change-email" size="sm" variant="ghost" onClick={() => setOpen(true)} className={className}>
        <AtSign size={15} className="sm:mr-1.5" /> <span className="hidden sm:inline">Email</span>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="change-email-dialog">
          <DialogHeader><DialogTitle>Cambia email</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <p className="text-xs text-muted-foreground">Email attuale: <span className="text-foreground">{user?.email}</span></p>
            <div><Label className="text-xs">Nuova email</Label><Input data-testid="ce-new-email" type="email" required value={newEmail} onChange={(e) => setNewEmail(e.target.value)} className="mt-1 bg-white" placeholder="nuova@email.com" /></div>
            <div><Label className="text-xs">Password attuale</Label><PasswordInput data-testid="ce-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-white" placeholder="Conferma con la tua password" /></div>
            <p className="text-xs text-muted-foreground">Dopo il salvataggio verrai disconnesso e dovrai accedere con la nuova email.</p>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
              <Button type="submit" data-testid="ce-submit" disabled={busy} className="bg-primary text-primary-foreground hover:bg-primary/90">{busy ? "Salvo…" : "Aggiorna email"}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
